import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useFormBuilder } from '../../../../contexts/FormBuilderContext'; // <--- 1. ИМПОРТИРУЕМ ХУК
import Input from '../../../common/Input/Input';
import { RATING_ICONS } from '../icon-pool';
import styles from './RatingEditor.module.css';

const MAX_ITEMS = 10;
const MIN_ITEMS = 3;

// 2. УБИРАЕМ КОЛБЭКИ ИЗ ПРОПСОВ. Компонент теперь принимает только 'question'.
const RatingEditor = ({ question }) => {
    const intl = useIntl();
    // 3. ПОЛУЧАЕМ НУЖНУЮ ФУНКЦИЮ ПРЯМО ИЗ КОНТЕКСТА
    const { updateQuestion } = useFormBuilder();

    const itemCount = question.options?.length || MIN_ITEMS;
    const currentIcon = question.config?.icon || 'star';

    const handleItemCountChange = (e) => {
        let newCount = parseInt(e.target.value, 10);
        if (isNaN(newCount) || newCount < MIN_ITEMS) newCount = MIN_ITEMS;
        if (newCount > MAX_ITEMS) newCount = MAX_ITEMS;
        if (newCount === itemCount) return;

        const currentOptions = question.options || [];
        const newOptions = [];

        for (let i = 0; i < newCount; i++) {
            newOptions.push(currentOptions[i] || { text: '', temp_id: `temp_${crypto.randomUUID()}` });
        }
        // 4. ВЫЗЫВАЕМ ФУНКЦИЮ ИЗ КОНТЕКСТА
        updateQuestion(question.id || question.temp_id, { options: newOptions });
    };

    const handleLabelChange = (index, newText) => {
        const newOptions = (question.options || []).map((option, i) => {
            if (i === index) {
                return { ...option, text: newText };
            }
            return option;
        });
        // 4. ВЫЗЫВАЕМ ФУНКЦИЮ ИЗ КОНТЕКСТА
        updateQuestion(question.id || question.temp_id, { options: newOptions });
    };

    const handleIconChange = (iconKey) => {
        // 4. ВЫЗЫВАЕМ ФУНКЦИЮ ИЗ КОНТЕКСТА
        updateQuestion(question.id || question.temp_id, { config: { ...question.config, icon: iconKey } });
    };

    return (
        <div className={styles.ratingEditor}>
            <div className={styles.settingRow}>
                <label className={styles.label}>{intl.formatMessage({ id: "ratingEditor.icon" })}:</label>
                <div className={styles.iconSelector}>
                    {Object.entries(RATING_ICONS).map(([key, { label, Icon }]) => (
                        <button
                            key={key}
                            title={label}
                            className={`${styles.iconButton} ${currentIcon === key ? styles.activeIcon : ''}`}
                            onClick={() => handleIconChange(key)}
                        >
                            <Icon />
                        </button>
                    ))}
                </div>
            </div>

            <div className={styles.settingRow}>
                <label htmlFor={`count-${question.id || question.temp_id}`} className={styles.label}>
                    <FormattedMessage id="ratingEditor.count" />:
                </label>
                <Input
                    type="number"
                    id={`count-${question.id || question.temp_id}`}
                    value={itemCount}
                    onChange={handleItemCountChange}
                    min={MIN_ITEMS}
                    max={MAX_ITEMS}
                    className={styles.countInput}
                    wrapperClassName={styles.noMarginBottom}
                />
            </div>

            <div className={styles.labelsContainer}>
                <label className={styles.label}>{intl.formatMessage({ id: "ratingEditor.labels" })}:</label>
                <div className={styles.labelsGrid}>
                    {Array.from({ length: itemCount }).map((_, index) => {
                        const option = question.options?.[index] || {};
                        return (
                            <Input
                                key={option.id || option.temp_id || `new-${index}`}
                                label={`${index + 1}`}
                                value={option.text || ''}
                                onChange={(e) => handleLabelChange(index, e.target.value)}
                                placeholder={intl.formatMessage({ id: "ratingEditor.label.placeholder" }, { value: index + 1 })}
                                wrapperClassName={styles.labelInputWrapper}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default RatingEditor;
